module.exports = __webpack_public_path__ + "img/OBCINA LOGATEC.712076ef.png";